// VoK MUI base styles
import colors from "app/assets/theme/base/colors";
import borders from "app/assets/theme/base/borders";
import boxShadows from "app/assets/theme/base/boxShadows";

// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

const {grey, white} = colors;
const {borderRadius} = borders;
const {tabsBoxShadow} = boxShadows;

const tabs = {
    styleOverrides: {
        root: {
            position: "relative",
            backgroundColor: grey[100],
            borderRadius: borderRadius.lg,
            minHeight: "unset",
            padding: pxToRem(4),
        },

        flexContainer: {
            height: "100%",
            position: "relative",
            zIndex: 10,
        },

        fixed: {
            overflow: "unset !important",
            overflowX: "unset !important",
        },

        vertical: {
            "& .MuiTabs-indicator": {
                width: "100%",
            },
        },

        indicator: {
            height: "100%",
            borderRadius: borderRadius.md,
            backgroundColor: white.main,
            boxShadow: tabsBoxShadow.indicator,
            transition: "all 500ms ease",
        },
    },
};

export default tabs;
